import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, take } from 'rxjs';
import { IApiResponse } from '../../../../../shared/models/api-response';
import { IUser } from '../../../../../shared/models/user';
import { AuthService } from '../../../../../shared/services/auth.service';
import { ToastService } from '../../../../../shared/services/toast.service';
import { IDonutChartItem } from '../../../../controls/donut-chart/donut-chart.component';
import { iecFinaliseVoteOption, iecFinaliseVoteId, IFinaliseIecBallotRequest } from '../../../shared/models/iec/iec-finalise-vote';
import { BallotCalculationService } from '../../../shared/services/ballot-calculation.service';
import { IecBallotService } from '../../../shared/services/iec-ballot.service';


@Component({
    selector: 'app-iec-finalise-ballot-modal',
    templateUrl: './iec-finalise-ballot-modal.component.html',
    styleUrl: './iec-finalise-ballot-modal.component.scss',
    standalone: false
})
export class IecFinaliseBallotModalComponent implements OnInit, OnDestroy  {
  @Input() data: IDonutChartItem[] = [];
  @Input() ballotId: string = '';


  inFavourOf = iecFinaliseVoteOption[iecFinaliseVoteId.inFavourOf];
  against = iecFinaliseVoteOption[iecFinaliseVoteId.against];
  abstain = iecFinaliseVoteOption[iecFinaliseVoteId.abstain];
  noResponse = iecFinaliseVoteOption[iecFinaliseVoteId.noResponse];
  isNoResponseFull: boolean = false;
  hasMajorityInFavorOf: boolean = false;
  hasMajorityAgainst: boolean = false;
  hasMajorityAbstain: boolean = false;
  isVoteTiedForFinalisation: boolean = false;
  defaultOption = iecFinaliseVoteOption[iecFinaliseVoteId.noResponse];
  isTwoValidOptions: boolean = false;
  currentUser: IUser | null = null;
  loginUserEmail: string = '';
  ballotData: IDonutChartItem[] = [];

  ballotForm!: FormGroup;

  finaliseIecBallotRequest: IFinaliseIecBallotRequest = {
    ballotId: '',
    FinalisedBy: '',
    ResolutionName: '',
  };

  subscriptions: Subscription = new Subscription();

  constructor(
    public _authService: AuthService,
    public activeModal: NgbActiveModal,
    public ballotCalculationService: BallotCalculationService,
    private _iecBallotService: IecBallotService,
    private _toastService: ToastService
  ) {
    this.initUser();
  }

  ngOnInit(): void {
    this.ballotForm = new FormGroup({
      ballotResponse: new FormControl({
        value: this.defaultOption.name,
        disabled: false,
      }),
    });

    this.checkFinaliseBallotStatus();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  initUser() {
    const currentUserSubscription = this._authService.currentUserSubject.subscribe((user) => {
      this.currentUser = user;

      if (!this.currentUser) return;
      this.loginUserEmail = this.currentUser.email;
    });

    this.subscriptions.add(currentUserSubscription);
  }

  checkFinaliseBallotStatus() {
    this.ballotData = this.ballotCalculationService.calculatePercentages(
      this.data
    );
    this.isNoResponseFull = this.ballotCalculationService.isNoResponseFull(
      this.ballotData
    );
    this.hasMajorityInFavorOf =
      this.ballotCalculationService.hasMajorityInFavorOf(this.ballotData);
    this.hasMajorityAgainst = this.ballotCalculationService.hasMajorityAgainst(
      this.ballotData
    );
    this.hasMajorityAbstain = this.ballotCalculationService.hasMajorityAbstain(
      this.ballotData
    );
    this.isVoteTiedForFinalisation =
      this.ballotCalculationService.isVoteTiedForFinalisation(this.ballotData);
    this.defaultOption = this.isNoResponseFull
      ? iecFinaliseVoteOption[iecFinaliseVoteId.noResponse]
      : this.hasMajorityInFavorOf
      ? iecFinaliseVoteOption[iecFinaliseVoteId.inFavourOf]
      : iecFinaliseVoteOption[iecFinaliseVoteId.against];
    this.isTwoValidOptions =
      this.isNoResponseFull ||
      this.hasMajorityInFavorOf ||
      this.hasMajorityAgainst;
    if (this.hasMajorityAbstain) {
      this.ballotForm.get('ballotResponse')?.setValue(null);
      return;
    }
    if (this.isTwoValidOptions) {
      this.ballotForm.get('ballotResponse')?.setValue(this.defaultOption.name);
    } else if (this.isVoteTiedForFinalisation) {
      this.ballotForm.get('ballotResponse')?.setValue(this.inFavourOf.name);
    }
  }

confirm() {
  this.finaliseIecBallotRequest.ballotId = this.ballotId;
  if (this.hasMajorityAbstain) {
      this.finaliseIecBallotRequest.ResolutionName = iecFinaliseVoteId.abstain;
  } else {
      const selectedValue = this.ballotForm.value.ballotResponse;
      this.finaliseIecBallotRequest.ResolutionName = selectedValue;
  }
  if (this.loginUserEmail) {
      this.finaliseIecBallotRequest.FinalisedBy = this.loginUserEmail;
  }

  this.subscriptions.add(this._iecBallotService.finaliseIECBallot(this.finaliseIecBallotRequest).subscribe({
    next: (response: IApiResponse<any>) => {
      if (response && response.success) {
        this.activeModal.dismiss('cancel');
        this._toastService.showSuccess("Ballot successfully finalised.", 'IEC Ballot');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    },
    error: (error) => {
      console.error('Inside error callback: ', error);
      this._toastService.showError("Unexpected error occurred. Please try again or contact IT Support.");
    }
  }));
}



  cancel() {
    this.activeModal.dismiss('cancel');
  }
}
